import type { IDynamicComponentContainer } from '@powerduck/components/app/dynamic-component-contracts';
import { isNullOrEmpty } from '@powerduck/common/utils/is-null-or-empty';

// Note: AppState is imported dynamically to avoid circular dependency at load time
// The getter functions only access AppState when called, not at module evaluation time
import type { AppState as AppStateType } from './app-state';
import { Language } from '@powerduck/common/enums/language';
const getAppState = (): typeof AppStateType => (window as any)['AppState'];

export class AppConfig {
	static _fullBlockerHtml = document.querySelector('.loading-full-overlay')?.outerHTML || `<div class="loading-full-overlay"><div class="loading-inner"><div class="loading-indicator-wrap"><div class="holdon-white holdon-overlay holdon-element"><div class="holdon-content"><div class="sk-rect"><div class="rect1"></div><div class="rect2"></div><div class="rect3"></div><div class="rect4"></div><div class="rect5"></div></div></div></div></div></div></div>`;
	static GOOGLE_API_KEY: string = 'AIzaSyCFVutK4VlYtcdoTd5SSfa0XzeNYfD69zw';
	static GEONAMES_USERNAME: string = 'tmr';
	static webComponentMode: boolean = false;

	private static _isDevHost: boolean = null;

	static get isDevHost(): boolean {
		if (this._isDevHost == null) {
			var h = location.hostname;
			this._isDevHost = h === 'localhost' || h === '127.0.0.1' || h.includes('invitondev') || h.includes('inviton1dev') || h.includes('inviton1-release-slot');
		}
		return this._isDevHost;
	}

	static get isDebugMode(): boolean {
		return this.isDevHost && (window as any).__appLiveMode != true;
	}

	static get cdnPath(): string {
		if (AppConfig.isDebugMode) {
			return '';
		}

		return (window as any).resourceCdnPath || '';
	}

	static get onBootstrapStyle(): 'primary' | 'info' {
		return 'primary';
	}

	static get logoPathSquare(): string {
		return getAppState()?.instanceConfig?.PortalSettings?.LogoUrlWhiteSquare || '/assets/img/logo_i.png';
	}

	static get logoPathRectangle(): string {
		return getAppState()?.instanceConfig?.PortalSettings?.LogoUrlWhiteTextOnly || '/assets/img/inviton-logo-white.svg';
	}

	static get breadcrumbEnabled(): boolean {
		return true;
	}

	static get blockerHtml(): string {
		return '<div class="holdon-white holdon-overlay holdon-element"><div class="holdon-content"><div class="sk-rect"><div class="rect1"></div><div class="rect2"></div><div class="rect3"></div><div class="rect4"></div><div class="rect5"></div></div></div></div>';
	}

	static get intransparentBlockerHtml(): string {
		return AppConfig._fullBlockerHtml;
	}

	static get blockerSelector(): string {
		return '.holdon-overlay';
	}

	static get rootDynamicComponentContainer(): IDynamicComponentContainer {
		return (window as any).RootDynamicContainerInstance;
	}

	static get supportedLanguages(): Language[] {
		return [
			Language.sk,
			Language.en,
			Language.de,
			Language.pl,
			Language.cs,
			Language.hu,
		];
	}

	static parseErrorMessage(respText: string): string {
		let parsedErr: any;
		if (respText == null || respText.indexOf('{') != 0) {
			return respText;
		}

		try {
			parsedErr = JSON.parse(respText);
		} catch (error) {
			parsedErr = respText as any;
		}

		if (!isNullOrEmpty(parsedErr?.messages)) {
			let msgBuilder = '';
			parsedErr.messages.forEach((msgData) => {
				if (!isNullOrEmpty(msgData.message)) {
					if (msgBuilder.length > 0) {
						msgBuilder += '\n\n';
					}

					msgBuilder += msgData.message;
				}
			});

			return msgBuilder;
		}

		return null;
	}
}


